import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Sparkles, Loader2 } from "lucide-react";
import { useAuth } from "../context/AuthContext";

export default function Register() {
  const { register, formatApiErrorDetail } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      await register(form.name, form.email, form.password);
      navigate("/");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-[80vh] flex items-center justify-center px-4 py-12" data-testid="register-page">
      <div className="w-full max-w-md bg-white rounded-3xl border-2 border-ink shadow-hard-lg p-8">
        <div className="flex items-center gap-2 mb-6">
          <div className="w-10 h-10 bg-brand-pink rounded-xl border-2 border-ink flex items-center justify-center"><Sparkles className="w-5 h-5 text-white" /></div>
          <span className="text-2xl font-black tracking-tighter">Snagly</span>
        </div>
        <h1 className="text-3xl font-black tracking-tight mb-1">Join the club 🎉</h1>
        <p className="text-muted-foreground mb-6">Create an account and start snagging.</p>

        {error && <div className="bg-brand-pink/10 border-2 border-brand-pink text-brand-pink rounded-xl px-4 py-3 text-sm font-bold mb-4" data-testid="register-error">{error}</div>}

        <form onSubmit={submit} className="space-y-4">
          <input required value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} placeholder="Full name"
            className="w-full bg-white border-2 border-ink rounded-xl px-4 py-3 focus:outline-none focus:ring-4 focus:ring-brand/20 font-medium" data-testid="register-name-input" />
          <input type="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} placeholder="Email address"
            className="w-full bg-white border-2 border-ink rounded-xl px-4 py-3 focus:outline-none focus:ring-4 focus:ring-brand/20 font-medium" data-testid="register-email-input" />
          <input type="password" required minLength={6} value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} placeholder="Password (min 6 chars)"
            className="w-full bg-white border-2 border-ink rounded-xl px-4 py-3 focus:outline-none focus:ring-4 focus:ring-brand/20 font-medium" data-testid="register-password-input" />
          <button type="submit" disabled={loading}
            className="w-full inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full font-bold bg-brand text-white border-2 border-ink shadow-hard-btn hover:translate-y-[3px] hover:shadow-none transition-all disabled:opacity-70" data-testid="register-submit-button">
            {loading ? <Loader2 className="w-5 h-5 animate-spin" /> : "Create Account"}
          </button>
        </form>

        <p className="text-center text-sm text-muted-foreground mt-6">
          Already have an account? <Link to="/login" className="text-brand font-bold" data-testid="go-to-login">Sign in</Link>
        </p>
      </div>
    </div>
  );
}
